import './rippleAvatar.scss';

interface RippleAvatarProps {
  size?: 'xs' | 'sm' | 'lg';
}

const RippleAvatar = ({ size = 'sm' }: RippleAvatarProps) => {
  return (
    <span
      className={`chat-ripple-avatar chat-ripple-avatar--${size}`}
      aria-hidden="true"
    >
      <span className="chat-ripple-avatar__core" />
      <span className="chat-ripple-avatar__wave chat-ripple-avatar__wave--1" />
      <span className="chat-ripple-avatar__wave chat-ripple-avatar__wave--2" />
      <span className="chat-ripple-avatar__wave chat-ripple-avatar__wave--3" />
    </span>
  );
};

export default RippleAvatar;
